import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion'

import { Box, Grid, Typography } from '@mui/material'
import { MenuSelectorField, ModelAutocompleteField } from '@front/squirtle'
import { UserUtils } from '@front/volcanion/utils'

const Row1 = () => {
  const autocompleteMutator = useCallback(q => ({
    or: [
      { info: { first_name: { startsWith: _.split(q, ' ') } } },
      { info: { last_name: { startsWith: _.split(q, ' ') } } },
      { auth: { username: { startsWith: q } } }
    ]
  }), [])

  return (
    <Grid container spacing={2} justifyContent='center' alignItems='center' size={12} >
      <Grid size={3}>
        <ModelAutocompleteField
          name='user'
          label={I18n.t('export.user.label')}
          model_name='user'
          searchMode='search'
          searchQuery='startsWith'
          autocompleteMutator={autocompleteMutator}
          config={{
            mutator: user => ({
              label: UserUtils.getFormatedName(user?.info, { prefix: user?.auth?.username }),
              ...user
            }),
            populate: ['auth', 'info']
          }}
          loadOnFocus={false}
        />
      </Grid>
      <Grid size={3}>
        <MenuSelectorField
          name='user_type'
          label={I18n.t('export.user_type.label')}
          multiple
          options={[
            { label: I18n.t('export.user_type.booker'), value: 'booker' },
            { label: I18n.t('export.user_type.operator'), value: 'operator' },
          ]}
        />
      </Grid>
      <Grid size={4}>
        <MenuSelectorField
          name='name'
          label={I18n.t('export.name.label')}
          multiple
          options={[
            { label: I18n.t('export.name.export_billing'), value: 'export_billing' },
            { label: I18n.t('export.name.export_job'), value: 'export_job' },
            { label: I18n.t('export.name.export_license'), value: 'export_license' },
            { label: I18n.t('export.name.export_order'), value: 'export_order' },
            { label: I18n.t('export.name.export_companyuser'), value: 'export_companyuser' },
            { label: I18n.t('export.name.export_companycontract'), value: 'export_companycontract' },
          ]}
        />
      </Grid>
    </Grid>
  );
}

const Form = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Grid size={9}>
        <Typography variant={'h5'}> {I18n.t('export.label', { count: -1 })} </Typography>
      </Grid>
      <Row1 {...props} />
    </Grid>
  </Box>

export default React.memo(Form)
